"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendAxiosConfigWithRequestOptionsForHeadersOnly = exports.extendAxiosConfigWithRequestOptionsForWrite = exports.extendAxiosConfigWithRequestOptions = exports.initiateAxiosClient = void 0;
var url_1 = require("url");
var axios_1 = require("axios");
var content_mgmt_api_service_1 = require("../content-mgmt-api.service");
function extractParamsFromUrl(axiosConfig) {
    if (axiosConfig && axiosConfig.url) {
        var offset = axiosConfig.url.indexOf('?');
        if (offset > -1) {
            var searchParams = new url_1.URLSearchParams(axiosConfig.url.substring(offset));
            searchParams.forEach(function (value, name) {
                if (!axiosConfig.params[name]) {
                    axiosConfig.params[name] = value;
                }
            });
            axiosConfig.url = axiosConfig.url.substring(0, offset);
        }
    }
    return axiosConfig;
}
function mergeAxiosRequestConfigs(configs) {
    return configs.reduce(function (accumulatedConfig, config) {
        var mergedConfig = Object.assign({}, accumulatedConfig, config);
        if (config.headers) {
            mergedConfig['headers'] = Object.assign(accumulatedConfig.headers ? accumulatedConfig.headers : {}, config.headers);
        }
        if (config.params) {
            mergedConfig['params'] = Object.assign(accumulatedConfig.params ? accumulatedConfig.params : {}, config.params);
        }
        return mergedConfig;
    }, {});
}
function initiateAxiosClient(endpoint, authentication, defaultRequestTimeout, defaultRequestHeaders) {
    var axiosInstance = axios_1.default.create();
    axiosInstance.defaults.baseURL = endpoint;
    axiosInstance.defaults.timeout = defaultRequestTimeout;
    axiosInstance.defaults.headers.common = Object.assign(axiosInstance.defaults.headers.common, authentication.getAuthenticationHeaders(), defaultRequestHeaders);
    return axiosInstance;
}
exports.initiateAxiosClient = initiateAxiosClient;
/**
 * builds the axios options by merging in the read relevant RequestOptions from the given parameter.
 * @param axiosConfig the default axios request config
 * @param options additional options, only the READING relevant attributes will be merged
 */
// eslint-disable-next-line complexity
function extendAxiosConfigWithRequestOptions(axiosConfig, options) {
    var requestQueryParams = {};
    if (options) {
        if (options.includeDraft) {
            requestQueryParams['includeDraft'] = 'true';
        }
        if (options.draft) {
            requestQueryParams['draft'] = 'true';
        }
        if (options.includeUnpublished) {
            requestQueryParams['includeUnpublished'] = 'true';
        }
        if (options.hydrateMasterWithLocalisation) {
            requestQueryParams['hydrateMasterWithLocalisation'] = 'true';
        }
        if (options.localeMixing && options.localeMixing.length > 0) {
            requestQueryParams['localeMixing'] = options.localeMixing.join(',');
        }
        if (options.requestQueryParams) {
            requestQueryParams = Object.assign(requestQueryParams, options.requestQueryParams);
        }
        if (options.include) {
            requestQueryParams['include'] = options.include.join(',');
        }
    }
    return mergeAxiosRequestConfigs([
        {
            params: requestQueryParams,
            headers: options && options.requestHeaders ? options.requestHeaders : {},
        },
        extractParamsFromUrl(axiosConfig),
    ]);
}
exports.extendAxiosConfigWithRequestOptions = extendAxiosConfigWithRequestOptions;
/**
 * builds the axios options by merging in the write relevant RequestOptions from the given parameter.
 * @param axiosConfig the default axios request config
 * @param options additional options, only the READING relevant attributes will be merged
 */
function extendAxiosConfigWithRequestOptionsForWrite(axiosConfig, queue, options) {
    var _a;
    var requestQueryParams = {};
    if (options) {
        // @ts-ignore: lowPrio is compatibility mode
        if (options.lowPriority) {
            requestQueryParams['priority'] = 'low';
        }
        if (options.wipeHistory) {
            requestQueryParams['wipeHistory'] = 'true';
        }
        if (options.validate !== undefined) {
            requestQueryParams['validate'] = options.validate.toString();
        }
        if (options.draft) {
            requestQueryParams['draft'] = 'true';
        }
        if (options.requestQueryParams) {
            requestQueryParams = Object.assign(requestQueryParams, options.requestQueryParams);
        }
    }
    if (queue === content_mgmt_api_service_1.Queue.LOW_PRIO) {
        requestQueryParams['priority'] = 'low';
    }
    else {
        delete requestQueryParams['priority'];
    }
    return mergeAxiosRequestConfigs([
        {
            params: requestQueryParams,
            headers: (_a = options === null || options === void 0 ? void 0 : options.requestHeaders) !== null && _a !== void 0 ? _a : {},
        },
        extractParamsFromUrl(axiosConfig),
    ]);
}
exports.extendAxiosConfigWithRequestOptionsForWrite = extendAxiosConfigWithRequestOptionsForWrite;
/**
 * builds the axios options by merging in the write relevant RequestOptions from the given parameter.
 * @param axiosConfig the default axios request config
 * @param options additional options, only the READING relevant attributes will be merged
 */
function extendAxiosConfigWithRequestOptionsForHeadersOnly(axiosConfig, options) {
    var requestQueryParams = {};
    return mergeAxiosRequestConfigs([
        {
            params: requestQueryParams,
            headers: options && options.requestHeaders ? options.requestHeaders : {},
        },
        extractParamsFromUrl(axiosConfig),
    ]);
}
exports.extendAxiosConfigWithRequestOptionsForHeadersOnly = extendAxiosConfigWithRequestOptionsForHeadersOnly;
//# sourceMappingURL=init-axios-client.util.js.map